module.exports = __webpack_public_path__ + "img/support2.ddf6e49e.png";